<template>
  <div id="info" :class="{ 'page-slide': 1, toggled }">
    <div class="column left">
      <div class="cell top">
        <div class="desktop content">
          <transition name="text" mode="out-in">
            <h2 v-html="slide.title" :key="activeSlide && toggled" />
          </transition>
          <transition name="text" mode="out-in">
            <div v-if="!toggled" v-html="slide.description" :key="activeSlide && toggled" />
          </transition>
        </div>
        <div class="mobile content">
          <transition name="text" mode="out-in">
            <h2 v-html="slide.title" :key="activeSlide && toggled" />
          </transition>
          <transition name="text" mode="out-in">
            <div v-html="slide.description" :key="activeSlide && toggled" />
          </transition>
        </div>
      </div>
      <transition name="bottom">
        <div class="desktop cell bottom" v-show="toggled">
          <InfoMenubar />
        </div>
      </transition>
      <InfoMenubar class="mobile" />
    </div>
    <div class="column right">
      <div class="cell top">
        <transition name="bg-img" mode="in-out">
          <div
            class="bg-img"
            :key="activeSlide && toggled"
            :style="`background-image: ${background};`"
          />
        </transition>
        <transition name="text">
          <div class="content" v-if="toggled" v-html="slide.description" />
        </transition>
      </div>
      <transition name="bottom">
        <div class="cell bottom" v-show="!toggled">
          <InfoMenubar />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InfoMenubar from "./InfoMenubar";

export default {
  name: "PageSlideInfo",
  components: { InfoMenubar },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters("languages", ["lang"]),
    ...mapGetters("infoSlides", ["activeSlide", "toggled"]),
    slide() {
      return this.lang.infoSlides[this.activeSlide - 1];
    },
    background() {
      let gradient = this.toggled
        ? "linear-gradient(to bottom, rgba(100, 0, 100, 1), rgba(100, 0, 100, 0.5)), "
        : "";
      return `${gradient}url(/assets/images/info-slides/info-slides-${this.activeSlide}.jpg)`;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-slide {
  position: absolute;
  height: 100%;
}
.column {
  position: absolute;
  height: 100%;
  transition-property: width;
  transition-duration: $info-slide-transition-duration;
  transition-timing-function: $info-slide-transition-timing-function;
}
.cell {
  position: relative;
  transition-property: all;
  transition-duration: $info-slide-transition-duration;
  transition-timing-function: $info-slide-transition-timing-function;
  overflow: hidden;
}
.left {
  width: $info-column-1-width;
  .top {
    height: 100%;
    background-color: $background-color-secondary-2;
    color: $color-primary-1;
    h2 {
      @extend #{$info-title-font-size};
      margin-bottom: $info-title-margin-bottom;
      font-weight: $info-title-font-weight;
    }
  }
}
.right {
  width: $info-column-2-width;
  right: 0;
  .top {
    height: $info-cell-top-height;
    .content {
      position: relative;
    }
  }
}
.bottom {
  height: $info-cell-bottom-height;
  background-color: $background-color-primary-1;
}
.content {
  @extend #{$info-content-font-size};
  width: 100%;
  height: 100%;
  padding: $info-content-padding;
  padding-top: $menubar-height + $page-padding-top;
}
.mobile {
  display: none;
}
.bg-img {
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.toggled {
  .left {
    width: $info-column-2-width;
    .top {
      height: 60%;
      background-color: $background-color-clear-1;
      color: $color-secondary-2;
    }
  }
  .right {
    width: $info-column-1-width;
    .top {
      height: 100%;
    }
  }
}

@media only screen and (max-width: $mobile-width) {
  .left {
    width: 100% !important;
    .top {
      height: $info-cell-top-height !important;
    }
    .desktop {
      display: none;
    }
    h2 {
      font-size: $info-mobile-title-font-size;
    }
    .content {
      font-size: $info-mobile-content-font-size;
    }
    .mobile {
      display: inline-block;
    }
  }
  .right {
    display: none;
  }
}

.text-enter-active,
.text-leave-active {
  transform-origin: 0 0;
  transition-property: all;
  transition-duration: $info-text-transition-duration;
  transition-timing-function: $info-text-transition-timing-function;
}

.text-enter-active {
  transition-delay: $info-slide-transition-duration;
}

.text-enter,
.text-leave-to {
  opacity: 0;
  transform: translateY($info-text-transition-translate-y);
}

.bg-img-enter-active,
.bg-img-leave-active {
  transition-property: transform;
  transition-duration: $info-slide-transition-duration;
  transition-timing-function: $info-slide-transition-timing-function;
}

.bg-img-enter {
  transform: translateY(100%);
}

.bg-img-leave-to {
  transform: translateY(-100%);
}

.bottom-enter-active,
.bottom-leave-active {
  transition-property: transform opacity;
  transition-duration: $info-cell-bottom-transition-duration;
  transition-timing-function: $info-cell-bottom-transition-timing-function;
}

.bottom-enter-active {
  transition-delay: $info-slide-transition-duration;
}

.bottom-enter,
.bottom-leave-to {
  opacity: 0;
  transform: translateY($info-cell-bottom-transition-transform-translate-y);
}
</style>
